<template>
  <div class="page">

    <!-- Content Section and Navigation Together -->
    <div class="content-wrapper">
      <!-- Content Section -->
      <div class="content-section">
        <div v-for="(item, index) in content.Items" :key="index" class="content-item">
          <div class="card">  
            <h1 class="title">{{ item.title }}</h1>
            <div class="card-header">
              <img :src="item.image" alt="Content Image" class="image" />
            </div>
            <div class="card-body">
              <div v-html="formattedDescriptionNo(item.description_no_1)" class="description_no"></div>
              <div v-html="formattedDescription(item.description_1)" class="description"></div>
              <div v-html="formattedDescriptionNo(item.description_no_2)" class="description_no"></div>
              <div v-html="formattedDescription(item.description_3)" class="description"></div>
              <div v-html="formattedDescriptionNo(item.description_no_3)" class="description_no"></div>
              <div v-html="formattedDescription(item.description_4)" class="description"></div>
            </div>
          </div>
        </div>
      </div>

      <!-- Contact Section (moved to the right) -->
      <div class="contact-container">
        <h2>Contact Information</h2>
        <div class="contact-info">
          <i class="fas fa-phone"></i>
          <p>Phone: 暂无(E-mail Only)</p>
        </div>
        <div class="contact-info">
          <i class="fas fa-envelope"></i>
          <p>Email: dankao.chen@nxtech.pub</p>
        </div>
        <!-- Add more contact info as needed -->
      </div>
    </div>
  </div>
</template>

<style src="@/assets/css/cases.css" scoped></style>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      cn: {
        Items: [
          {
            id: 1,
            image: require("@/assets/img/PlanandCases/AIGC/BataHumanPage/MetaHumanShangguan.jpg"),
            title: "云翰虹章推出的虚拟数字人：Meta-Human",
            description_no_1:`
              <strong class="bold-text">1. 引言</strong>
            `,
            description_1:`
              云翰虹章推出的虚拟数字人不仅具备自然的语言交互能力和基本的情感识别功能，还拥有精心设计的外型，能够与用户进行流畅对话，并根据用户情绪调整对话策略，为用户提供良好的互动体验。虚拟数字人能够在多个方面为企业和个人提供服务，例如企业介绍、项目展示以及咨询问询等。
              
              在2024年，我们为宁波诺丁汉大学（UNNC）定制了一款专属的UNNC虚拟数字人，提升了学校在招生、学生生活支持和学术辅助方面的能力，为学校的发展提供了如下多方面的支持。
            `,
            description_no_2:`
              <strong class="bold-text">2. 招生宣传与咨询</strong>
            `,
            description_3:`
                <strong class="bold-text"> 全天候支持：</strong> UNNC虚拟数字人可以24/7全天候提供咨询和支持。无论是在工作日还是周末，无论是白天还是夜晚，在校学生和潜在申请学生都可以随时获取所需的信息。
                <strong class="bold-text"> 实时回答问题：</strong> 虚拟人能够实时解答潜在学生关于学校和专业的各种问题，例如课程设置、校园生活、入学要求等。通过自然的对话和准确的信息，虚拟人能够帮助学生更好地了解UNNC，提升他们的兴趣和申请意愿。
                <strong class="bold-text"> 提升招生转化率：</strong> 凭借高效的咨询和支持功能，虚拟人显著提升了潜在学生对UNNC的了解，增加了学校的吸引力，最终提高了招生转化率。
            `,
            description_no_3:`
              <strong class="bold-text">3. 学术辅助功能</strong>
            `,
            description_4:`
              <strong class="bold-text"> 学习辅助：</strong>虚拟人为在校学生提供全面的学习支持，解答各种学术问题。例如在基本的计算机知识领域，无论是编程、算法还是计算机网络架构，虚拟人都能够提供有针对性的解答和建议。
              <strong class="bold-text"> 资源推荐：</strong>根据学生的需求和学习进度，虚拟人能够推荐相关的学习资源、书籍和在线课程，帮助学生更好地掌握知识，提高学习效率。
              <strong class="bold-text"> 个性化支持：</strong>虚拟人通过分析学生的学习习惯和需求，提供个性化的学习建议，帮助学生在学术上取得更大的进步。

              通过云翰虹章推出的虚拟数字人，宁波诺丁汉大学（UNNC）不仅提升了自身的服务水平，还为学生和潜在学生提供了更加便捷和个性化的支持。未来，随着技术的不断进步，虚拟数字人将会在更多领域发挥更大的作用，为更多人带来便利和支持。
            `,
          },
          // Add more items as needed
        ],
      },
      en: {
        Items: [
          {
            id: 2,
            image: require("@/assets/img/PlanandCases/AIGC/BataHumanPage/MetaHumanShangguan.jpg"),
            title: "Rosy Nebula：Meta-Human",
            description_no_1:`
              <strong class="bold-text">1. Intro</strong>
            `,
            description_1:`
              Rosy Nebula's "Meta-Human" not only has natural language interaction capability and basic emotion recognition function, but also has a well-designed appearance, which is able to have a smooth dialogue with the user and adjust the dialogue strategy according to the user's emotion, providing a good interactive experience for the user. Meta-Human is able to serve businesses and individuals in a number of ways, such as corporate presentations, project presentations and enquiries. 
              
              In 2024, we customised an exclusive UNNC Virtual Human for the University of Nottingham Ningbo (UNNC) to enhance the university's capabilities in recruitment, student life support, and academic support, providing the following aspects of the university's development.
            `,
            description_no_2:`
              <strong class="bold-text">2. Admissions Promotion and Counselling</strong>
            `,
            description_3:`
                <strong class="bold-text"> Round-the-clock support: </strong> The UNNC Virtual Human is available 24/7 for advice and support. On weekdays and weekends, day or night, current students and potential applicants can access the information they need at any time.
                <strong class="bold-text"> Real-Time QA: </strong> Meta Human is able to answer a wide range of student questions about schools and majors in real time, such as course offerings, campus life, admission requirements, and more. Through natural dialogue and accurate information, it can help students better understand UNNC and enhance their interest and willingness to apply.
                <strong class="bold-text"> Boost enrolment conversion rates: </strong> With its highly effective counselling and support functions, Meta Human significantly improves potential students' understanding of UNNC, increases the school's attractiveness, and ultimately improves enrolment conversion rates.
            `,
            description_no_3:`
              <strong class="bold-text">3. Academic support functions</strong>
            `,
            description_4:`
              <strong class="bold-text"> Study aids: </strong> Meta Human provides comprehensive learning support for school students, answering a wide range of academic questions. For example, in the area of basic computer literacy, whether it is programming, algorithms or computer network architecture, Meta Human is able to provide targeted answers and advice.
              <strong class="bold-text"> Resource Recommendations: </strong> Based on students' needs and learning progress, Meta Human is able to recommend relevant learning resources, books and online courses to help students better master their knowledge and improve their learning efficiency.
              <strong class="bold-text"> Personalised support: </strong> Meta Human helps students achieve greater academic progress by analysing their study habits and needs and providing personalised study advice.

              With the launch of Meta Human by Rosy Nebula, the University of Nottingham Ningbo (UNNC) has not only improved its own services, but also provided more convenient and personalised support to students and potential students. In the future, as technology continues to advance, Meta Human will play a greater role in more areas, bringing convenience and support to more people.
            `,
          },
          // Add more items as needed
        ],
      },
    };
  },
  methods: {
    formattedDescription(description) {
      // Apply additional formatting if needed
      return description.replace(/\n\s*\n/g, '<br /><br />'); // Convert double newlines to paragraph breaks
    },
    formattedDescriptionNo(description_no) {
      // Apply additional formatting if needed
      return description_no.replace(/\n\s*\n/g, '<br /><br />'); // Convert double newlines to paragraph breaks
    },
  },
  mixins: [],
  computed: {
    ...mapState(["language"]),
    content() {
      const defaultContent = { title: "", industry_areas: [] };
      const currentLanguage = this.language === "en" ? this.en : this.cn;
      console.log("Current Language:", currentLanguage); // Debug statement
      return currentLanguage || defaultContent;
    },
  },
  watch: {
    language(newValue) {
      console.log("Language changed to:", newValue); // Debug statement
      this.$forceUpdate(); // Force the component to re-render when the language changes
    },
  },
};
</script>
